import { useEffect, useMemo, useState } from 'react';
import { ProductCard } from './ProductCard';
import { AgencyBundleCard } from './AgencyBundleCard';
import { UpsellCard } from './UpsellCard';
import { Templately } from './Templately';
import {
	AGENCY_BUNDLE_ID,
	APPSUMO_EAE_TIER_3_BUNDLE_ID,
} from '../../../utils/AgencyBundleProducts';

export function ProductCardList({ cartData, ...restProps }) {
	const [showFree, setShowFree] = useState(false);
	const [eaAppSumo, setEaAppSumo] = useState(false);
	const [monthFree, setMonthFree] = useState(1);

	const agencyLifetime = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return cartData?.contents?.find(
			item =>
				+item.id === AGENCY_BUNDLE_ID &&
				+item.options.price_id >= 2 &&
				+item.options.price_id != 5
		);
	}, [cartData]);

	const cartHasAgencyBundle = useMemo(() => {
		if (!cartData) {
			return false;
		}

		return cartData?.contents?.find(item => +item.id === AGENCY_BUNDLE_ID);
	}, [cartData]);

	const cartHasAppSumoBundle = useMemo(() => {
		if (!cartData) {
			return false;
		}

		return cartData?.contents?.find(
			item => +item.id === APPSUMO_EAE_TIER_3_BUNDLE_ID
		);
	}, [cartData]);

	const cartHasBetterDocs = useMemo(() => {
		if (!cartData) {
			return false;
		}

		return (
			cartData?.details?.filter(item => +item.id === 342422)?.length > 0
		);
	}, [cartData]);

	useEffect(() => {
		if (cartData && cartData.details && cartData.details.length) {
			const [ea] = cartData.details.filter(
				item => parseInt(item.id) === 4372
			);
			const [eaAppSumo] = cartData.details.filter(
				item => parseInt(item.id) === 234326
			);
			if (ea) {
				setShowFree(true);
				switch (parseInt(ea.item_number?.options?.price_id)) {
					case 3:
						setMonthFree(3);
						break;
					case 4:
						setMonthFree(6);
						break;
					default:
						setMonthFree(1);
						break;
				}
			} else if (eaAppSumo) {
				setEaAppSumo(true);
				setShowFree(true);
				switch (parseInt(eaAppSumo.item_number?.options?.price_id)) {
					case 3:
						setMonthFree(3);
						break;
					case 4:
						setMonthFree(6);
						break;
					default:
						setEaAppSumo(false);
						setShowFree(false);
						break;
				}
			} else {
				const [eb] = cartData.details.filter(
					item => parseInt(item.id) === 1677666
				);
				if (eb) {
					setShowFree(true);
					switch (parseInt(eb.item_number?.options?.price_id)) {
						case 2:
							setMonthFree(3);
							break;
						case 3:
						case 4:
						case 5:
						case 6:
							setMonthFree(6);
							break;
						default:
							setMonthFree(1);
							break;
					}
				} else {
					setShowFree(false);
				}
			}
		}
	}, [cartData]);

	const cartViews = useMemo(() => {
		if (cartData?.details) {
			const onlyProductCard = false;
			return cartData?.details.map((product, idx) => {
				if (product.id == 1882016 && cartHasBetterDocs) {
					return;
				}

				return (
					<li
						key={product?.name ?? idx}
						className={`wp-checkout-product-card-list-item ${!onlyProductCard ? 'no-border' : ''}`}
					>
						<ProductCard
							{...restProps}
							cartIndex={idx}
							cartData={cartData}
							product={product}
							isAgencyLifetime={agencyLifetime}
							cartHasAgencyBundle={cartHasAgencyBundle}
							cartHasAppSumoBundle={cartHasAppSumoBundle}
							showFree={showFree}
							monthFree={monthFree}
						/>
					</li>
				);
			});
		}

		return [];
	}, [cartData, showFree, monthFree]);

	return (
		<ul className="wp-checkout-product-card-list">
			{cartViews}

			<li className={`wp-checkout-product-card-list-item no-border`}>
				{showFree && !restProps.renewalDiscount && (
					<Templately
						appSumo={eaAppSumo}
						month={monthFree}
					/>
				)}
			</li>

			<li className={`wp-checkout-product-card-list-item no-border`}>
				<UpsellCard
					{...restProps}
					cartData={cartData}
				/>
			</li>
		</ul>
	);
}
